import api from './api';

/**
 * Fetches the data needed to map promotion paths.
 * @returns {Promise<Object>} An object containing current and future year classes.
 */
export const getPromotionPaths = async () => {
    try {
        const response = await api.get('/promotions/paths');
        return response.data;
    } catch (error) {
        console.error("Error fetching promotion paths:", error);
        throw error;
    }
};

/**
 * Updates the promotion link for a single class.
 * @param {number} classId - The ID of the class in the current year.
 * @param {number | null} promotesToClassId - The ID of the class in the future year, or null.
 * @returns {Promise<Object>} The server response.
 */
export const updatePromotionPath = async (classId, promotesToClassId) => {
    try {
        const response = await api.put(`/promotions/paths/${classId}`, { promotesToClassId });
        return response.data;
    } catch (error) {
        console.error("Error updating promotion path:", error);
        throw error;
    }
};